<template>
  <div class="md-layout">
    <customer-list></customer-list>
  </div>
</template>

<script>
import CustomerList from "./CustomerList";

export default {
  components: {
    CustomerList
  }
};
</script>
